module.exports = __webpack_public_path__ + "static/media/odiopay-logo-white.fa4c1f94.svg";